/** Formatting and empty-state pieces shared by the optimizer screens (Token Optimization, RTK, Headroom, Graphify). */

export const wholeNumber = (value: number) => Math.round(value).toLocaleString();

/** "1.2M" for axis ticks and KPI headline figures — same notation as the Executive view's money formatter, without currency. */
export function compactNumber(value: number): string {
  return new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 }).format(Math.round(value));
}

export type SectionHeadingProps = { title: string; hint?: string; info?: string };

export function ReadingGuide({ children }: { children: string }) {
  return (
    <aside className="rounded-card border border-border bg-surface-alt px-4 py-3 text-xs leading-relaxed text-text-muted">
      <p className="font-medium text-text-default">How to read these figures</p>
      <p className="mt-1">{children}</p>
    </aside>
  );
}

export function ChartEmptyState({ label }: { label: string }) {
  return <div className="flex h-full items-center justify-center text-sm text-text-muted">{label}</div>;
}
